import Typography from '@material-ui/core/Typography';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { setSectionsReload } from '../../core/actions';
import DefaultSettings from '../../core/controls/components/settings';
import { PostData } from '../../core/controls/helpers/requests';
import { GetData, PutData } from '../../core/modules/form/formsapi';
import { requestApi } from '../../core/modules/form/utilities';
import { getEnvVariable } from '../../modules/environmentalList';
const _ = require('lodash');

/*
1. Do not add extra conditions. No Conditions are allowed 
2. Do not add any extra functions.
3. Do not add any extra hooks.
4. Use getAconditionBasedOnProject to set sitepermittypeworkflowid based on Project
*/

/**
 * Represents a workflow component.
 * @param {Object} props - The props for the component.
 * @returns {JSX.Element} The rendered workflow component.
 */
export default function CWorkflow(props) {
    // Props and state declarations
    const { fieldValues, handleFieldValue, items = [] } = props;
    const dispatch = useDispatch();
    const params = useParams();
    const extrapropsworkflow = useSelector(state => state.header && state.header.extrapropsworkflow);
    const [firstSet, setFirstSet] = useState({});
    const [prevFieldValues, setPrevFieldValues] = useState(fieldValues);

    // Cleanup function for useEffect
    useEffect(() => {
        if ((prevFieldValues && fieldValues) && (
            (fieldValues['SitepermittypeWorkflowId'] && prevFieldValues['SitepermittypeWorkflowId'] && fieldValues['SitepermittypeWorkflowId'] === prevFieldValues['SitepermittypeWorkflowId']) ||
            (fieldValues['WorkflowId'] && prevFieldValues['WorkflowId'] && fieldValues['WorkflowId'] === prevFieldValues['WorkflowId'])))
            setFirstSetFun()
        return () => {
            setFirstSet();
            setPrevFieldValues({});
        };
    }, []);

    // Effect to handle changes in fieldValues
    useEffect(() => {
        if (
            fieldValues &&
            Object.keys(fieldValues).length > 0 &&
            prevFieldValues &&
            Object.keys(prevFieldValues).length > 0 &&
            (fieldValues['SitepermittypeWorkflowId'] !== prevFieldValues['SitepermittypeWorkflowId'] ||
                fieldValues['WorkflowId'] !== prevFieldValues['WorkflowId'] ||
                ((fieldValues['Add'] === true || fieldValues['Add'] === '0') && fieldValues['Add'] !== prevFieldValues['Add'])
            )
        ) {
            setFirstSetFun();
            setPrevFieldValues(fieldValues);
        }
    }, [fieldValues]);

    // Function to get a condition based on the project
    const getAconditionBasedOnProject = () => {
        const project = getEnvVariable('ModuleKey');
        switch (project) {
            case 'UPS':
                return fieldValues['PhaseType'] === null ? null : fieldValues.SitepermittypeWorkflowId;
            case 'LAOACS':
                return fieldValues['Upgrade'] === 'Y'
                    ? null
                    : fieldValues.SitepermittypeWorkflowId || extrapropsworkflow.SitePermitTypeAppSettingsId;
            default:
                return fieldValues.SitepermittypeWorkflowId || extrapropsworkflow.SitePermitTypeAppSettingsId;
        }
    }

    // Deep compare effect hook
    function useDeepCompareEffect(callback, dependencies) {
        const firstRenderRef = useRef(true);
        const dependenciesRef = useRef(dependencies);

        if (!_.isEqual(dependencies, dependenciesRef.current)) {
            dependenciesRef.current = dependencies;
        }

        useEffect(() => {
            if (firstRenderRef.current) {
                firstRenderRef.current = false;
                return;
            }

            return callback();
        }, [dependenciesRef.current]);
    }

    // Effect to load workflows based on conditions
    useDeepCompareEffect(() => {
        if (firstSet && Object.keys(firstSet).length > 0) {
            loadWorkflowsBasedOnConditions();
        }
    }, [firstSet]);

    // Function to set the firstSet state
    const setFirstSetFun = () => {
        let firstTempSet = {};
        setFirstSet({
            ...firstTempSet,
            ...{
                IsAdmin: props.IsAdmin,
                WorkflowId: fieldValues['Add'] ? 0 : fieldValues['WorkflowId'],
                ParentWorkflowId: '',
                workflowitems: [],
                defaultworkflow: '',
                configType: extrapropsworkflow.configType,
                configId: extrapropsworkflow.configId,
                SitepermittypeWorkflowId: fieldValues['Add'] === true ? 0 : getAconditionBasedOnProject(),
                IsCurrent: fieldValues.IsCurrent
            }
        });
    }

    // Function to load workflows based on conditions
    const loadWorkflowsBasedOnConditions = () => {
        var workflowId = firstSet['WorkflowId'];
        var SitepermittypeWorkflowId = firstSet['SitepermittypeWorkflowId'];
        var takeIsDefault = extrapropsworkflow && extrapropsworkflow.takeIsDefault;

        if ((workflowId && workflowId > 0) || (SitepermittypeWorkflowId && SitepermittypeWorkflowId > 0)) {
            // Load the workflow
            functionInitalMount(false);
        } else if (fieldValues['Add']) {
            loadMasterflow(false);
        } else if (takeIsDefault) {
            functionInitalMount(true);
        }
    }

    // Function to handle the initial mount
    const functionInitalMount = (isDefault) => {
        if (firstSet && Object.keys(firstSet).length > 0) {
            if (firstSet.IsAdmin) {
                loadAdminflow();
            } else {
                if (firstSet && (firstSet.SitepermittypeWorkflowId > 0 && firstSet.WorkflowId > 0)) {
                    workflowprocessMain();
                } else {
                    loadMasterflow(isDefault);
                }
            }
        } else {
            loadMasterflow(isDefault);
        }
    }

    // Function to load admin flow
    const loadAdminflow = () => {
        var sourceURL = getEnvVariable('AdminConfig') + "/api/SitePermitTypeWorkflow/" + params.routeid + `/${extrapropsworkflow.configId}/SitePermitWorkFlows`;
        DefaultSettings.getAlert('Please wait, Information is processing', 'info');
        GetData(sourceURL, "").then(results => {
            if (results && results.length > 0) {
                var firstResult = results[0];
                setFirstSet({ ...firstResult });
            }
            workflowprocessAdmin();
        }).catch(ex => {
            DefaultSettings.getAlert('Unable to process the workflow ', 'error');
        });
    }

    // Function to load master flow
    const loadMasterflow = (isDefault = false) => {
        const { ParentWorkflowId, WorkflowId, configId } = firstSet;
        var sourceURL = getEnvVariable('AdminConfig') + "/api/SitePermitTypeWorkflow/" + params.routeid + `/${extrapropsworkflow.configId}/SitePermitWorkFlows`;
        if (params.routeid && params.routeid1) {
            DefaultSettings.getAlert('Please wait, Information is processing', 'info');
            GetData(sourceURL, "").then(results => {
                if (results && results.length > 0) {
                    let defaultworkflowval = null;
                    let defaultworkflowitem = _.find(results, { IsDefault: 'Y' });
                    defaultworkflowval = defaultworkflowitem ? defaultworkflowitem.WorkflowId : null;
                    if (defaultworkflowval && isDefault) {
                        let loadworkflow = WorkflowId === "" ? _.find(results, { IsDefault: 'Y' }) :
                            ParentWorkflowId !== 0 ? _.find(results, { "WorkflowId": Number(ParentWorkflowId) }) : null;
                        var tempfirstResult = loadworkflow ? loadworkflow : (defaultworkflowitem || results[0]);
                        setFirstSet({
                            ...tempfirstResult,
                            ParentWorkflowId: WorkflowId ? WorkflowId : tempfirstResult.WorkflowId,
                            workflowitems: results,
                            workflowval: loadworkflow ? tempfirstResult.WorkflowId : "",
                            disableddropdown: WorkflowId ? true : false,
                            resetbutton: WorkflowId ? true : false,
                            defaultworkflow: defaultworkflowval
                        });
                        let defaultSet = {
                            ...tempfirstResult,
                            ParentWorkflowId: WorkflowId ? WorkflowId : tempfirstResult.WorkflowId,
                            workflowitems: results,
                            workflowval: loadworkflow ? tempfirstResult.WorkflowId : "",
                            disableddropdown: WorkflowId ? true : false,
                            resetbutton: WorkflowId ? true : false,
                            defaultworkflow: defaultworkflowval
                        };
                        workflowprocessMain(defaultSet);
                    } else {
                        let currentset = _.find(results, { Id: fieldValues['SitepermittypeWorkflowId'] > 0 ? fieldValues['SitepermittypeWorkflowId'] : null });
                        if (currentset) {
                            let defaultSet = {
                                ...currentset,
                                ParentWorkflowId: currentset.WorkflowId,
                                workflowitems: results,
                                workflowval: currentset.WorkflowId || "",
                                defaultworkflow: null
                            };
                            setFirstSet({ ...defaultSet });
                            workflowprocessMain(defaultSet);
                        } else if (fieldValues['Add']) {
                            workflowprocessMain();
                        } else {
                            if (fieldValues['SitepermittypeWorkflowId'] < 1 && fieldValues['WorkflowId'] > 0);
                            workflowprocessMain();
                        }
                    }
                } else {
                    let sitepermittypeWorkflowId = fieldValues['SitepermittypeWorkflowId'] || 0;
                    setFirstSet({
                        ...firstSet,
                        ...fieldValues,
                        "ParentWorkflowId": 0,
                        workflowval: "",
                        workflowitems: results,
                        disableddropdown: false,
                        resetbutton: false,
                        defaultworkflow: null
                    });
                    let defaultSet = {
                        ...firstSet,
                        ...fieldValues,
                        "ParentWorkflowId": sitepermittypeWorkflowId,
                        workflowval: "",
                        workflowitems: results,
                        defaultworkflow: null
                    };
                    workflowprocessMain(defaultSet);
                }
            }).catch(ex => {
                // Handle error
            });
        } else {
            DefaultSettings.getAlert('Unable to process the workflow ', 'error');
        }
    }

    // Function to handle workflow process for admin
    const workflowprocessAdmin = () => {
        var isAdd = (firstSet.WorkflowId) <= 0;
        let RoleRegionsurl = `/InternalAccessControlView/GetUserRoleConfigTypeForWorkflowActiveUsers/` + getEnvVariable('ModuleKey') + `/${firstSet.configType}/?isAdmin=${props.IsAdmin}&configIds=${firstSet.configId}`;
        if (typeof window.workflowObj !== "undefined") {
            if (isAdd) {
                window.workflowObj.render({
                    isAdmin: props.IsAdmin,
                    el: "#play",
                    userdata: RoleRegionsurl,
                    success: function (e) {
                        if (e.id) {
                            let resultdata = {
                                isDefault: 'N',
                            };
                            var sourceURL = getEnvVariable('AdminConfig') + "/api/SitePermitTypeWorkflow/" + firstSet.SitePermitTypeAppSettingsId + "/" + e.id + "/add";
                            let finalurl = { url: sourceURL };
                            let url = { post: finalurl };
                            requestApi(url, [], resultdata).then(response => {
                                // Handle success
                            }).catch(ex => {
                                // Handle error
                            });
                        }
                    }
                });
            } else {
                window.workflowObj.render({
                    isAdmin: props.IsAdmin,
                    id: firstSet.WorkflowId,
                    el: "#play",
                    userdata: RoleRegionsurl,
                    success: function (e) {
                        // Handle success
                    }
                });
            }
        }
    }

    // Function to handle workflow save
    const handleWorkflowSave = () => {
        let tempworkflowid = fieldValues['WorkflowId'] ? parseInt(fieldValues['WorkflowId']) : 0;
        if (isNaN(tempworkflowid)) {
            tempworkflowid = 0;
        }
        if (tempworkflowid === 0) {
            return true;
        } else if (
            firstSet.WorkflowId === undefined ||
            firstSet.WorkflowId === null ||
            firstSet.WorkflowId <= 0
        ) {
            return true;
        } else {
            return false;
        }
    }

    // Function to handle the main workflow process
    const workflowprocessMain = (defaultSet = null, ASWID = null) => {
        var isAdd = handleWorkflowSave();
        let RoleRegionsurl = `/InternalAccessControlView/GetUserRoleConfigTypeForWorkflowActiveUsers/` + getEnvVariable('ModuleKey') + `/${extrapropsworkflow.configType}/?isAdmin=${props.IsAdmin ? true : false}&configIds=${extrapropsworkflow.configId} `;
        if (typeof window.workflowObj !== "undefined") {
            if (isAdd && ASWID === null) {
                DefaultSettings.getAlert('Please wait, Information is processing', 'info');
                window.workflowObj.render({
                    parentid: defaultSet ? defaultSet.ParentWorkflowId : firstSet.ParentWorkflowId,
                    isAdmin: props.IsAdmin,
                    el: "#play",
                    userdata: RoleRegionsurl,
                    success: function (e) {
                        var parentworkflowidval = defaultSet ? defaultSet.ParentWorkflowId : (firstSet.ParentWorkflowId !== "" ? firstSet.ParentWorkflowId : 0);
                        let workflowid = e.id ? e.id : firstSet.WorkflowId;
                        setFirstSet({ ...firstSet, ...e });
                        handleFieldValue({ target: { value: workflowid, name: "WorkflowId" } });
                        var applicationUpdateUrl = getEnvVariable('Application') + "/api/Application/UpdateWorkflow/" + `${params.routeid}` + "/" + `${params.routeid1}` + "?&status=&workflowid=" + workflowid + "&parentworkflowid=" + parentworkflowidval;
                        PutData(applicationUpdateUrl, null).then(function (res) {
                            if (res && workflowid && props.fieldValues && params) {
                                let workflowsaveurl = props.fieldProps.save.url.read[0];
                                let url = workflowsaveurl.url;
                                let id;
                                workflowsaveurl.matchProps.forEach(each => {
                                    const { key } = each;
                                    id = workflowsaveurl.matchProps ? params[key] : null;
                                    url = `${url.replace(`{${key}}`, id)}`;
                                });
                                let bodyobj = {};
                                bodyobj.WorkflowId = workflowid;
                                bodyobj.IsCurrent = 'Y';
                                bodyobj.RefType = 'A';
                                bodyobj.RefId = params.routeid1;
                                bodyobj.PhaseType = fieldValues['PhaseType'];
                                bodyobj.sitepermittypeWorkflowId = fieldValues['SitepermittypeWorkflowId'];
                                PostData(url, bodyobj, true).then(result => {
                                    if (result) {
                                        var applicationUpdateUrl = getEnvVariable('Application') + "/api/Application/UpdateWorkflow/" + `${params.routeid}` + "/" + `${params.routeid1}` + "?&status=&workflowid=" + workflowid + "&parentworkflowid=" + parentworkflowidval;
                                        PutData(applicationUpdateUrl, null).then(function (res) {
                                            if (res) {
                                                console.log("res", res)
                                                window.workflowObj.data.submit(workflowid, function () {
                                                    DefaultSettings.getAlert().show('Workflow Saved Successfully', 'success');
                                                    // dispatch(setSectionsReload(true));

                                                    if (workflowid) {
                                                        props.handleBack(true);
                                                        //  workflowprocessMain(defaultSet, workflowid)

                                                    }
                                                }, function () {
                                                    // Handle error
                                                });
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            } else {
                window.workflowObj.render({
                    isAdmin: props.IsAdmin || false,
                    id: ASWID ? ASWID : defaultSet ? defaultSet.WorkflowId : firstSet.WorkflowId,
                    parentid: defaultSet ? defaultSet.ParentWorkflowId : firstSet.ParentWorkflowId,
                    el: "#play",
                    userdata: RoleRegionsurl,
                    success: function (e) {
                        DefaultSettings.getAlert().show('Workflow Updated Successfully', 'success');
                        props.handleBack(true);
                        //setSectionsReload(true);
                        //  props.handleBack(true);
                    }
                });
            }
        }
    }

    return (
        <>
            {/* {firstSet && Object.keys(firstSet).length > 0 && (
                <Typography variant={'body2'} className="fw-bold">
                    Is Current: {(fieldValues && fieldValues['IsCurrent'] === 'N' ? "No" : "Yes") || 'Yes'}
                </Typography>
            )} */}
            <div className="sketch_ToolBox_Widget" >
                <div id="play" className="workflow-wrapper"></div>
            </div>
        </>
    );
}
